import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

type ClassName = string | number | boolean | null | undefined | ClassName[];

export function cn(...inputs: ClassName[]) {
  return twMerge(clsx(inputs));
}
